export function getUrl(names) {
    if (!Array.isArray(names)) {
        names = [names];
    }
    const text = encodeURIComponent(
        window.__('whatsapp.url_text', { count: names.length }) + names.join(', ')
    );
    return `https://api.whatsapp.com/send/?phone=49441219751919&text=${text}`;
}
